module.exports = __webpack_public_path__ + "static/img/ld.f1a3d44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mimg/ld.png
// module id = Uq/y
// module chunks = 4